export default "__VITE_ASSET__CJuNoHww__"